var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("div", { staticClass: "title mb-40" }, [
        _vm._v("Histórico de saques")
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _vm.preloader
            ? _c("PreloaderTable")
            : _c(
                "div",
                { key: "1", staticClass: "table" },
                [
                  _c(
                    "table",
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [_vm._v("Data")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Valor")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Status")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "transition",
                        { attrs: { name: "fade", mode: "out-in" } },
                        [
                          _c(
                            "tbody",
                            _vm._l(10, function(n) {
                              return _c("tr", { key: n }, [
                                _c("td", [_vm._v("15/10/2018 - 10:36")]),
                                _vm._v(" "),
                                _c("td", [_vm._v("R$ 60,00")]),
                                _vm._v(" "),
                                _c("td", [_vm._v("encaminhado")])
                              ])
                            }),
                            0
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("Pagination", {
                    attrs: { pagination: _vm.pagination },
                    on: {
                      changePage: function($event) {
                        return _vm.setCurrentPage($event)
                      }
                    }
                  })
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b16f5fdc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b16f5fdc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WalletOfCompany/History.vue
// module id = null
// module chunks = 